// @generated by protobuf-ts 2.11.0 with parameter server_generic,generate_dependencies,long_type_number
// @generated from protobuf file "packages/sdk/protos/SdkRpc.proto" (syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { OperatorDiscovery } from "./SdkRpc";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { OperatorDiscoveryResponse } from "./SdkRpc";
import type { OperatorDiscoveryRequest } from "./SdkRpc";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service OperatorDiscovery
 */
export interface IOperatorDiscoveryClient {
    /**
     * @generated from protobuf rpc: discoverOperators
     */
    discoverOperators(input: OperatorDiscoveryRequest, options?: RpcOptions): UnaryCall<OperatorDiscoveryRequest, OperatorDiscoveryResponse>;
}
/**
 * @generated from protobuf service OperatorDiscovery
 */
export class OperatorDiscoveryClient implements IOperatorDiscoveryClient, ServiceInfo {
    typeName = OperatorDiscovery.typeName;
    methods = OperatorDiscovery.methods;
    options = OperatorDiscovery.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: discoverOperators
     */
    discoverOperators(input: OperatorDiscoveryRequest, options?: RpcOptions): UnaryCall<OperatorDiscoveryRequest, OperatorDiscoveryResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<OperatorDiscoveryRequest, OperatorDiscoveryResponse>("unary", this._transport, method, opt, input);
    }
}
